module.exports = "/desktop-app/assets/img/error.png?ae52320b030fe33ed25defe83da7d66a";


//////////////////
// WEBPACK FOOTER
// ./foody/src/assets/common/images/icon/error.png
// module id = NXtl
// module chunks = 1